<div class="dialog-wrapper">
  <h3 mat-dialog-title>{{ title }}</h3>
  <div mat-dialog-content>
    <table mat-table matTableResponsive [dataSource]="vidVehiclePage?.content">
      <ng-container matColumnDef="carStatus">
        <th mat-header-cell *matHeaderCellDef> {{ 'reports.reportTable.status' | translate }} </th>
        <td mat-cell *matCellDef="let element" class="table-icon column-spacing" [ngClass]="element.carStatusCss">
          <mat-icon>car_crash</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="vehicleId">
        <th mat-header-cell *matHeaderCellDef>
          <div class="flex-row start-center gap-10">
            {{ data.productType === 'BODY' ? ('reports.filterLabel.vehicleId' | translate) : 'Id' }}
            @if (data.productType === 'BODY') {
              <mat-icon class="link-color">open_in_new</mat-icon>
            }
          </div>
        </th>
        <td mat-cell *matCellDef="let element" class="no-wrap column-spacing"
          [ngClass]="element.lineType === 'B' ? 'action-cell' : ''"
          matTooltip="{{ 'notification.linkTooltip' | translate }}" [matTooltipPosition]="'above'" [matTooltipDisabled]="element.lineType !== 'B'"
          (click)="showCarReport(element)">{{ element.vehicleId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="redComps">
        <th mat-header-cell *matHeaderCellDef> nOK {{ 'dashboard.components' | translate }} </th>
        <td mat-cell *matCellDef="let element"
          class="column-spacing no-wrap component-column"
          [matTooltip]="element.redComps"
          matTooltipClass="component-column-tooltip"
          matTooltipPosition="above"
          [matTooltipShowDelay]="500">
          {{ element.redComps }}
        </td>
      </ng-container>
      <ng-container matColumnDef="model">
        <th mat-header-cell *matHeaderCellDef> {{ 'reports.filterLabel.carType' | translate }} </th>
        <td mat-cell *matCellDef="let element" class="no-wrap column-spacing"> {{ element.model }} </td>
      </ng-container>
      <ng-container matColumnDef="line">
        <th mat-header-cell *matHeaderCellDef> {{ 'reports.reportTable.line' | translate }} </th>
        <td mat-cell *matCellDef="let element" class="no-wrap column-spacing"> {{ element.line }} </td>
      </ng-container>
      <ng-container matColumnDef="measurementDate">
        <th mat-header-cell *matHeaderCellDef> {{ 'reports.reportTable.dateMeasurement' | translate }} </th>
        <td mat-cell *matCellDef="let element" class="no-wrap column-spacing">  {{ element.measurementDate | date: 'yyyy-MM-dd HH:mm' }}  </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          {{ 'notification.noData' | translate }}
        </td>
      </tr>
    </table>
    <mat-paginator [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [length]="totalSize"
      [pageIndex]="currentPage"
      (page)="pageEvent($event)"
      showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator>
    @if (isLoading) {
      <colimo-loader [isRelative]="true" style="width: 50%; height: 50%;"></colimo-loader>
    }
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Ok</button>
  </div>
</div>
